/**
 * Constants for API endpoints
 */

// check if the environment variable is set
if (process.env.REACT_APP_SERVER_URL === undefined) {
    console.error('REACT_APP_SERVER_URL is not set. Using default value.');
}
export const SERVER_URL = process.env.REACT_APP_SERVER_URL;
export const VIMEO_OEMBED_URL = 'https://vimeo.com/api/oembed.json?url=';

/**
 * Error messages
 */

export const ERROR_MESSAGES = {
    INVALID_CREDENTIALS: 'Invalid credentials',
    UNAUTHORIZED_ACCESS: 'Unauthorized access. Please log in to access the page.',
    FORBIDDEN_ACCESS: 'Forbidden access. You do not have permission to view this page.',
    NOT_FOUND: 'Not found',
    BAD_REQUEST: 'Some information is missing or incorrect. Please review and resubmit.',
}

/**
 * Activity Types
 */

export const ACTIVITY_TYPES = Object.freeze({
    USER_LOGGED_IN:       'USER_LOGGED_IN',
    USER_LOGGED_OUT:      'USER_LOGGED_OUT',
    USER_WATCHED_VIDEO:   'USER_WATCHED_VIDEO',
    USER_COMPLETED_VIDEO: 'USER_COMPLETED_VIDEO',
    USER_SUBMITTED_SURVEY:'USER_SUBMITTED_SURVEY',
    USER_VISITED_VACCINE_INFO_PAGE: 'USER_VISITED_VACCINE_INFO_PAGE',
    USER_SCROLLED_VACCINE_INFO_PDF: 'USER_SCROLLED_VACCINE_INFO_PDF',
    USER_OPENED_VACCINE_INFO_PDF: 'USER_OPENED_VACCINE_INFO_PDF',
})